import { IconRefresh } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useGetBannedIPsQuery } from "@sso/apis/BannedIP/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectBannedIPPagination } from "@sso/store/slices/bannedIP";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";

import { BannedIPTable } from "./BannedIPTable";
import { bannedIPTableColumns } from "./bannedIPTableColumns";

export const BannedIP = () => {
  const theme = useTheme();

  const bannedIPPagination = useAppSelector(selectBannedIPPagination);

  const { data, isFetching, error, refetch } = useGetBannedIPsQuery();

  const tableContextInstance: TableProviderState = { ...bannedIPPagination, columns: bannedIPTableColumns };

  const TableActions = (
    <Flex>
      <IconButton title="Refresh" onClick={refetch}>
        <IconRefresh />
      </IconButton>
    </Flex>
  );

  return (
    <>
      {isFetching && <CircleLoading color={theme.colors.secondary.dark} size={8} blurBackground />}
      <TableProvider tableInstance={tableContextInstance}>
        <TableHeader title="Banned IP" TableActions={TableActions} />
        <TableLayoutWrapper error={error} data={data}>
          {data && <BannedIPTable bannedIPList={data.resources} />}
        </TableLayoutWrapper>
        <TablePagination totalPages={data?.totalPages} />
      </TableProvider>
    </>
  );
};
